import * as React from "react";
import { mergeClassNames } from "./class-names";

export type SkeletonProps = Omit<
  React.ComponentPropsWithoutRef<"div">,
  "aria-hidden" | "children"
>;

export const Skeleton = React.forwardRef<HTMLDivElement, SkeletonProps>(
  ({ className, ...props }, ref) => (
    <div
      ref={ref}
      data-slot="skeleton"
      aria-hidden="true"
      className={mergeClassNames(
        "animate-pulse rounded-md bg-border-subtle motion-reduce:animate-none",
        className,
      )}
      {...props}
    />
  ),
);
Skeleton.displayName = "Skeleton";
